<template>
  <div class="list">
    <header-bar :isIndex="true"></header-bar>
    <section class="main cl">
      <div class="main-left fl">
        <div class="search-box">
          <span @click="searchTypeFlag = !searchTypeFlag" :class="{ open: searchTypeFlag }">
            {{ searchTypeData[searchType] }}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <ul class="classtify" v-show="searchTypeFlag">
            <li v-for="(item,i) in searchTypeData"
              @click="searchType=i; searchTypeFlag = false;" :key="i">
              {{ item }}
            </li>
          </ul>
          <input type="text" placeholder="输入搜索的内容" v-model="currKey" />
          <el-button type="text" class="el-icon-search" @click="toSearch"></el-button>
        </div>
        <div class="content">
          <p class="search-count">为您找到相关结果约{{ count }}个</p>
          <div class="news-list"
            v-infinite-scroll="getData"
            infinite-scroll-disabled="busy"
            infinite-scroll-
            distance="10"
          >
            <template v-if="currType==0">
              <news-list
              v-for="(item, i) in dataList"
              :key="i"
              :dataList="item"
            ></news-list>
            </template>

            <template v-else-if="currType==1">
              <activity-list
              v-for="(item, i) in dataList"
              :key="i"
              :dataList="item"
            ></activity-list>
            </template>
            <div v-else v-for="item in dataList" :key="item.id" class="user-item">
              <img @click="userCenter(item.id)" :src="item.icon||'/static/img/mr-usericon.png'" alt="">
              <span @click="userCenter(item.id)">{{ item.userName }}<img v-if="item.certify == 1" class="dv-rz" src="/static/img/d-v-rz.png" alt=""></span>
              <el-button v-if="item.attentionFlag==0" type="danger" size="small" plain @click="attention(item)">关注</el-button>
              <el-button v-else type="info" size="small" plain>已关注</el-button>
            </div>
            <div v-if="dataLoadNomore" class="loading-all">没有更多数据</div>
            <div v-else class="loading">正在加载中，请稍等…</div>
          </div>
        </div>
      </div>
      <div class="main-right fr">
        <com-foot></com-foot>
      </div>
    </section>
    <back-top></back-top>
  </div>
</template>

<script>
import HeaderBar from "@/components/Header.vue";
import NewsList from "@/components/NewsList.vue";
import BackTop from "@/components/BackTop.vue";
import ComFoot from "@/components/ComFoot.vue";
import ActivityList from "@/components/ActivityList.vue";
import infiniteScroll from "vue-infinite-scroll";
export default {
  name: "List",
  directives: { infiniteScroll },
  components: {
    HeaderBar,
    NewsList,
    ActivityList,
    BackTop,
    ComFoot
  },
  data() {
    return {
      searchTypeFlag: false,
      searchTypeData: ["文章", "活动", "用户名"],
      searchType: this.$route.query.type,
      currType: this.$route.query.type,
      currKey: this.$route.query.key,
      busy: false,
      dataLoadNomore: false,
      page: 1,
      size: 10,
      count: 0,
      dataList: [],
      articleHotDataList: [],
      hotPage: 1,
      hotPages: "",
      hyhFlag: false
    };
  },
  methods: {
    userCenter(id) {
      this.$router.push("/usercenter/" + id);
    },
    toSearch(){
      this.currType = this.searchType;
      this.$router.push('/search?key='+ this.currKey +'&type='+ this.currType);

      this.page = 1;
      this.count = 0;
      this.dataList = [];
      this.getData();
    },
    attention(obj) {
      this.$api.attentionHandle({
          userId: obj.id
        })
        .then((res) => {
          this.$message.success(res.data.msg)
          obj.attentionFlag = !obj.attentionFlag
        });
    },
    getData() {
      this.busy = true;
      this.$api.search({
          current: this.page,
          size: this.size,
          type: this.currType,
          keywords: this.currKey
        })
        .then((res) => {
          this.page==1 && (this.count = res.data.data.total);
          res.data.data.records.forEach((item, index) => {
            if (item.imgStr) {
              item.imgStr = item.imgStr.split(",");
            } else {
              item.imgStr = [];
            }
          });
          this.dataList = this.dataList.concat(
            res.data.data.records
          );
          if (res.data.data.current < res.data.data.pages) {
            this.page += 1;
            this.busy = false;
            this.dataLoadNomore = false;
          } else {
            this.dataLoadNomore = true;
          }
        });
    },
    hotData() {
      this.$api
        .articleList({
          channelId: 0,
          current: this.hotPage,
          size: 10,
          type: 4,
        })
        .then((res) => {
          this.articleHotDataList = res.data.data.records;
          this.hotPages = res.data.data.pages;
          if(res.data.data.pages > 1) {
            this.hyhFlag = true
          }
        });
    }
  },
  created() {
    this.getData();
    this.hotData();
  },
};
</script>

<style scoped lang="scss">
.main {
  width: 1000px;
  margin: 10px auto;
  margin-top: 70px;
  .main-left {
    background: #fff;
    width: 680px;
    .search-box {
      position: relative;
      background: #fff;
      font-size: 15px;
      display: flex;
      margin: 24px 24px 16px;
      border: 1px solid #E6E6E6;
      border-radius: 3px;
      span {
        color: #535353;
        cursor: pointer;
        width: 85px;
        border-right: 1px solid #E6E6E6;
        line-height: 40px;
        text-align: center;
        i {
          transition: all 0.3s;
          transform-origin: center;
        }
        &.open {
          i {
            transform: rotate(180deg);
          }
        }
      }
      .classtify {
        position: absolute;
        left: 0;
        top: 40px;
        width: 73px;
        background: #ffffff;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07);
        border-radius: 2px;
        color: #535353;
        padding: 10px 0;
        z-index: 2;
        li {
          padding: 0 13px;
          line-height: 2;
          cursor: pointer;
          font-size: 15px;
          &.on,
          &:hover {
            background: #f5f5f5;
            color: #317DFF;
          }
        }
      }
      input {
        height: 42px;
        width: 75%;
        background: none;
        border: none;
        padding-left: 12px;
      }
      button {
        color: #fff;
        font-size: 20px;
        padding: 0;
        width: 72px;
        background: #317DFF;
        border-radius: 0px 3px 3px 0px;
        position: absolute;
        right: 0;
        height: 44px;
        top: -1px;
      }
    }
    .content{
      border-top: 1px solid #E6E6E6;
      padding: 24px;
      .search-count{
        color: #999999;
        font-size: 16px;
      }
      /deep/ .news-item{
        padding: 24px 0;
      }
      .user-item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #EFEFEF;
        padding-bottom: 15px;
        margin-top: 15px;
        img{
          width: 48px;
          height: 48px;
          border-radius: 50%;
          cursor: pointer;
        }
        span{
          width: 79%;
          text-align: left;
          cursor: pointer;
          .dv-rz {
            width: 14px;
            height: 14px;
            margin-left: 5px;
          }
        }
      }
    }
    .loading {
      width: 680px;
      height: 52px;
      background: url("../assets/images/loading-icon.png") no-repeat 238px
        center;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.07);
      font-size: 15px;
      font-weight: 400;
      color: #666666;
      border-top: 10px solid #f7f7f7;
      text-align: center;
      line-height: 42px;
    }
    .loading-all {
      width: 680px;
      height: 52px;
      font-size: 15px;
      font-weight: 400;
      color: #666666;
      text-align: center;
      line-height: 42px;
      margin-top: 20px;
    }
  }
  .main-right {
    width: 310px;
    .hot-post-top10 {
      color: #121212;
      .post-title {
        font-size: 18px;
        font-weight: 600;
        padding: 18px 11px 18px 40px;
        background: url("../assets/images/icon/hot.png") center left 10px
          no-repeat;
        border-bottom: 1px solid #efefef;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 14px;
          font-weight: 400;
          color: #8c8c8c;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search.vue